/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_AuthenticationInputs */

const en_directory_agent_readiness_check_authentication = /** @type {(inputs: Directory_Agent_Readiness_Check_AuthenticationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authentication documentation`)
};

const zh_directory_agent_readiness_check_authentication = /** @type {(inputs: Directory_Agent_Readiness_Check_AuthenticationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`认证文档`)
};

/**
* | output |
* | --- |
* | "Authentication documentation" |
*
* @param {Directory_Agent_Readiness_Check_AuthenticationInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_authentication = /** @type {((inputs?: Directory_Agent_Readiness_Check_AuthenticationInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_AuthenticationInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_authentication(inputs)
	return zh_directory_agent_readiness_check_authentication(inputs)
});
export { directory_agent_readiness_check_authentication as "directory.agent_readiness.check.authentication" }